import { BrowserRouter, Route, Routes } from 'react-router';
import AppLayout from './components/AppLayout';
import OpenAPIViewer from './components/OpenAPIViewer';
import { APPS_PATH, PRICING_PATH, ROUTER_BASE_PATH } from './constants';
import { UserApps, NewApp } from './components/MyApps';
import './App.css';
import MyAppsLayout from './components/MyApps/Layout';
import { Pricing } from './components/Pricing';
import UserDataBoundary from './components/UserDataBoundary';

const App = () => (
  <BrowserRouter basename={ROUTER_BASE_PATH}>
    <Routes>
      <Route path="/" element={<AppLayout />}>
        <Route
          path={APPS_PATH}
          element={
            <UserDataBoundary>
              <MyAppsLayout />
            </UserDataBoundary>
          }
        >
          <Route index element={<UserApps />} />
          <Route path="new" element={<NewApp />} />
        </Route>
        <Route
          path={PRICING_PATH}
          element={
            <UserDataBoundary>
              <Pricing />
            </UserDataBoundary>
          }
        />
        <Route index element={<OpenAPIViewer />} />
        <Route path="*" element={<OpenAPIViewer />} />
      </Route>
    </Routes>
  </BrowserRouter>
);

export default App;
